import Card from "@mui/material/Card";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "domain";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import {
  TextField,
  Button,
  Grid,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import authorsTableData from "layouts/Inquiry/data/authorsTableData";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function Tables() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    designation: "",
    organization: "",
    phone: "",
  });
  const [tableData, setTableData] = useState({ columns: [], rows: [] });

  const handleClickView = (uid) => {
    navigate(`/profile?uid=${uid}`);
  };

  const handleClickDelete = async (inqid) => {
    if (confirm("Do you really want to delete this Inquiry ?")) {
      try {
        const response = await axios.delete(`https://${baseurl}/deleteInquiry?inqid=${inqid}`);
        if (response.status === 200) {
          alert("Inquiry Deleted Successfully!");
          setTableData((prevData) => ({
            ...prevData,
            rows: prevData.rows.filter((row) => row.inqid !== inqid),
          }));
        } else {
          alert("Try Again");
        }
      } catch (error) {
        alert("Error Deleting Inquiry");
        console.error("Error deleting Inquiry:", error);
      }
    }
  };

  const handleEditClick = (uid) => {
    navigate(`/profileEdit?uid=${uid}`);
  };

  // Fetch table data
  const fetchTableData = async () => {
    const result = await authorsTableData(
      filters,
      handleClickView,
      handleClickDelete,
      handleEditClick
    );
    setTableData(result);
  };

  // Fetch table data whenever filters change
  useEffect(() => {
    fetchTableData();
  }, [filters]);

  // Redirect if no token
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/authentication/sign-in");
    }
  }, [navigate]);

  // Handle filter change
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // Handle filter clear
  const handleClearFilters = async () => {
    // Reset filters
    setFilters({
      name: "",
      email: "",
      designation: "",
      organization: "",
      phone: "",
    });
    // Fetch table data with cleared filters
    fetchTableData();
  };

  // Handle add user click
  const handleClick = () => {
    navigate("/AddUser");
  };

  // Handle download functionality
  const handleDownload = () => {
    const keysToExclude = ["uid"];
    const transformedData = tableData.rows.map((row) => {
      const newItem = { ...row };
      keysToExclude.forEach((key) => delete newItem[key]);
      return newItem;
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "data.xlsx");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <MDTypography variant="h6" color="white">
                      Member Inquiries
                    </MDTypography>
                  </Grid>
                </Grid>
              </MDBox>
              <Grid container spacing={2} padding={3} alignItems="center">
                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    name="name"
                    value={filters.name}
                    onChange={handleChange}
                    label="name"
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    name="email"
                    value={filters.email}
                    onChange={handleChange}
                    label="email"
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    name="designation"
                    value={filters.designation}
                    onChange={handleChange}
                    label="designation"
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    name="organization"
                    value={filters.organization}
                    onChange={handleChange}
                    label="organization"
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    name="phone"
                    value={filters.phone}
                    onChange={handleChange}
                    label="phone"
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={handleClearFilters}
                    style={{ color: "white" }}
                  >
                    Clear
                  </Button>
                </Grid>
                {/* <Grid item xs={12} sm={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownload}
                    style={{ color: 'white' }}
                  >
                    Download
                  </Button>
                </Grid> */}
              </Grid>
              <MDBox mx={2} pt={3}>
                <DataTable
                  table={{ columns: tableData.columns, rows: tableData.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
